import TableRowsAge from './TableRowsAge';

const tableStyle = {
  textAlign: 'center',
  borderRadius: '10px',
  backgroundColor: 'RGB(188,232,253)',
  width: '100%',
  tableLayout: 'auto',
};

function CubeTestReportAgePanel({
  visible,
  rowsData,
  noOfMouldsCasted = 0,
  onAddRow,
  onDeleteRow,
  onChangeRow,
  onGenerateRow,
}) {
  if (!visible) {
    return (
      <div className="form-row shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel container">
        <span style={{ color: '#475569', fontSize: '0.92rem' }}>
          Select a pending delivery above to configure age and mould details.
        </span>
      </div>
    );
  }

  return (
    <div className="form-row shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel container">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap',
          marginBottom: '8px',
          width: '100%',
        }}
      >
        <div>
          <strong>Age &amp; Mould Setup</strong>
          <div style={{ fontSize: '0.85rem', fontWeight: 'normal', marginTop: '2px' }}>
            Cube ID is auto-filled from customer initials, grade, age and DC date. Click Generate on each age row (7-day or 28-day) without clearing the other age.
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flex: '0 1 auto',
          }}
        >
          <label htmlFor="no_of_moulds" style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>
            No. of Moulds Casted
          </label>
          <input
            type="text"
            id="no_of_moulds"
            readOnly
            value={noOfMouldsCasted || 0}
            className="form-control"
            style={{
              width: '72px',
              backgroundColor: 'white',
              cursor: 'not-allowed',
              textAlign: 'center',
            }}
          />
        </div>
      </div>

      <div className="table-responsive" style={{ width: '100%' }}>
        <table
          className="table-bordered table-responsive searchTable table order-list mb-0"
          style={tableStyle}
        >
          <thead style={{ backgroundColor: '#bce8fd' }}>
            <tr>
              <th style={{ width: '72px', verticalAlign: 'middle' }}>Action</th>
              <th style={{ verticalAlign: 'middle' }}>Age (days)</th>
              <th style={{ verticalAlign: 'middle' }}>No. of Moulds</th>
              <th style={{ verticalAlign: 'middle' }}>Mould Casting Area</th>
              <th style={{ verticalAlign: 'middle', minWidth: '220px' }}>Cube ID</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="5" className="text-left p-1">
                <button type="button" className="btn btn-success btn-sm" onClick={onAddRow}>
                  + Add age row
                </button>
              </td>
            </tr>
            <TableRowsAge
              rowsData={rowsData}
              deleteTableRows={onDeleteRow}
              handletableChange={onChangeRow}
              onGenerateRow={onGenerateRow}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CubeTestReportAgePanel;
